import { HelpType } from "../../components/Help/Help";
import { useLocation } from "react-router";
import { useHttp } from "../../hooks/useHttp";
import { Task, TaskBatch } from "../../models/tasks";
import { useEffect, useState } from "react";
import { LayoutMode, StatsMap } from "../Tasks/Tasks";
import { Box, Button, Divider, Typography } from "@mui/material";
import { CreateTaskModal } from "../../components/CreateTaskModal/CreateTaskModal";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import AddIcon from "@mui/icons-material/Add";
import { BatchItem } from "../../components/BatchItem/BatchItem";
import { BatchComponent } from "../../components/BatchComponent/BatchComponent";
import RefreshIcon from "@mui/icons-material/Refresh";

interface BatchInterface {
  authenticated: boolean;
  setHelp: React.Dispatch<React.SetStateAction<HelpType>>;
}

export const Batch = ({ authenticated, setHelp }: BatchInterface) => {
  const location = useLocation();

  const {
    loading: fetched_tasks_loading,
    error: fetched_tasks_error,
    trigger: fetchTasks,
  } = useHttp<TaskBatch[]>("/batch/preview");

  const [tasks, setTasks] = useState<TaskBatch[]>([]);
  const [selectedTask, setSelectedTask] = useState<TaskBatch | null>(null);
  const [createTaskModalOpen, setCreateTaskModalOpen] = useState<boolean>(false);
  const [taskViewOpen, setTaskViewOpen] = useState<boolean>(true);
  const [pipelineStats, setPipelineStats] = useState<StatsMap | null>(null);
  const [layoutMode, setLayoutMode] = useState<LayoutMode>(
    window.innerWidth > 1300
      ? LayoutMode.DEFAULT
      : window.innerWidth > 1000
        ? LayoutMode.FOLDED_SIDEBAR
        : LayoutMode.MOVE_IMAGES,
  );
  useEffect(() => {
    fetchTasks().then((r: TaskBatch[]) => {
      setTasks(r);
    });
  }, []);

  useEffect(() => {
    if (tasks && tasks.length > 0) {
      const params = new URLSearchParams(location.search);
      const taskId = params.get("id");
      if (taskId) {
        const task = tasks.find((t) => t.id === taskId);
        if (task) {
          setSelectedTask(task);
        }
      }
    }
  }, [location.search, tasks]);

  const refreshTask = async () => {
    fetchTasks().then((r: TaskBatch[]) => {
      setTasks(r);
    });
  };

  return (
    <div className={"page tasks"}>
      {createTaskModalOpen && (
        <CreateTaskModal
          open={createTaskModalOpen}
          handleClose={() => {
            setCreateTaskModalOpen(false);
            const params = new URLSearchParams(location.search);
            params.delete("create");
            const newUrl = `${location.pathname}?${params.toString()}`;
            window.history.replaceState(null, "", newUrl);
          }}
          setTasks={setTasks}
          setHelp={setHelp}
          isBatch={true}
        />
      )}
      <Box className={layoutMode !== LayoutMode.DEFAULT ? "tasks-body tasks-body-mobile" : "tasks-body"}>
        {taskViewOpen && layoutMode > LayoutMode.DEFAULT && (
          <div className="tasks-list-shadow" onClick={() => setTaskViewOpen(false)} />
        )}
        <div className={taskViewOpen ? "tasks-list" : "tasks-list tasks-list-collapsed"}>
          {layoutMode !== LayoutMode.DEFAULT && (
            <div className="tasks-list-header tasks-list-header-sidebar">
              {!taskViewOpen && <KeyboardDoubleArrowRightIcon onClick={() => setTaskViewOpen(true)} />}
              {taskViewOpen && <KeyboardDoubleArrowLeftIcon onClick={() => setTaskViewOpen(false)} />}
            </div>
          )}
          {layoutMode !== LayoutMode.DEFAULT && <Divider flexItem />}
          <div className="tasks-list-header">
            {taskViewOpen && (
              <Typography variant={"h2"} className="tasks-header-title">
                Batch Tasks
              </Typography>
            )}
            <div>
              <AddIcon onClick={() => setCreateTaskModalOpen(true)} />
              <RefreshIcon onClick={() => refreshTask()} />
            </div>
          </div>

          {fetched_tasks_loading && <Typography variant={"h2"}>Loading...</Typography>}
          {fetched_tasks_error && <Typography variant={"h2"}>Error: {fetched_tasks_error.message}</Typography>}
          {taskViewOpen &&
            tasks &&
            tasks.length !== 0 &&
            tasks
              .slice()
              .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
              .map((task, index: number) => (
                <div key={index} style={{ width: "100%" }}>
                  {index !== 0 && <Divider flexItem />}
                  <BatchItem task={task} selected={selectedTask?.id === task.id} key={task.id} open={taskViewOpen} />
                </div>
              ))}
          {tasks && tasks.length === 0 && (
            <Box className={"tasks-noTasksFound"}>
              <Typography variant={"h3"}>No batch tasks found for current session</Typography>
              <Button onClick={() => setCreateTaskModalOpen(true)}>Create first batch task</Button>
            </Box>
          )}
        </div>
        <Divider orientation={"vertical"} flexItem />
        <Box
          className={"tasks-taskComponentWrapper"}
          style={layoutMode !== LayoutMode.DEFAULT ? { marginLeft: "4rem" } : {}}
        >
          {selectedTask && (
            <>
              <BatchComponent
                taskId={selectedTask.id}
                refresh={() => refreshTask()}
                pipelineStats={pipelineStats}
                layoutMode={layoutMode}
                completedTasksNumber={selectedTask.completedTasksNumber}
              />
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};
